<template>
  <div>
    <vs-row>
      <vs-col vs-type="flex" vs-align="start" vs-w="2">
        <span class="sdf-text-18-400-light-navy">スラスタ</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <span class="sdf-text-17-400-light-navy mr-6">バウ</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <span class="sdf-text-17-400-light-navy mr-6">No.1翼角</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <span class="sdf-text-17-400-light-navy mr-6">No.2翼角</span>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-align="start" vs-w="2"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <current-bow-thruster-operation-amount-starboard-direction
          :value="currentBowThrusterOperationAmountStarboardDirection"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <bow-thruster1-pitch :value="bowThruster1Pitch"/>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <bow-thruster2-pitch :value="bowThruster2Pitch"/>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-align="start" vs-w="2"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <span class="sdf-text-17-400-light-navy mr-6">スタン</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <span class="sdf-text-17-400-light-navy mr-6">No.1翼角</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <span class="sdf-text-17-400-light-navy mr-6">No.2翼角</span>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-type="flex" vs-align="start" vs-w="2"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <current-stern-thruster-operation-amount-starboard-direction
          :value="currentSternThrusterOperationAmountStarboardDirection"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <stern-thruster1-pitch :value="sternThruster1Pitch"/>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="3">
        <stern-thruster2-pitch :value="sternThruster2Pitch"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import { isNumber } from "lodash";
import {ColorMixin} from "@/mixins/addon/secure-dataflow";

// components
import CurrentBowThrusterOperationAmountStarboardDirection
  from "./components/CurrentBowThrusterOperationAmountStarboardDirection";
import CurrentSternThrusterOperationAmountStarboardDirection
  from "./components/CurrentSternThrusterOperationAmountStarboardDirection";
import BowThruster1Pitch from "./components/BowThruster1Pitch";
import BowThruster2Pitch from "./components/BowThruster2Pitch";
import SternThruster1Pitch from "./components/SternThruster1Pitch";
import SternThruster2Pitch from "./components/SternThruster2Pitch";

// Store
const {
  mapState: mapStateOfMonitoringVesselManeuvering
} = createNamespacedHelpers("sdfMonitoringVesselManeuvering");

export default {
  mixins: [ColorMixin],
  components: {
    CurrentBowThrusterOperationAmountStarboardDirection,
    CurrentSternThrusterOperationAmountStarboardDirection,
    BowThruster1Pitch,
    BowThruster2Pitch,
    SternThruster1Pitch,
    SternThruster2Pitch
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapStateOfMonitoringVesselManeuvering({
      channelDataManeuvering: state => state.channelDataManeuvering
    }),
    currentBowThrusterOperationAmountStarboardDirection() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB34.vn)) {
          return Number(this.channelDataManeuvering.SB34.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    currentSternThrusterOperationAmountStarboardDirection() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB35.vn)) {
          return Number(this.channelDataManeuvering.SB35.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    bowThruster1Pitch() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB38.vn)) {
          return Number(this.channelDataManeuvering.SB38.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    bowThruster2Pitch() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB39.vn)) {
          return Number(this.channelDataManeuvering.SB39.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    sternThruster1Pitch() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB40.vn)) {
          return Number(this.channelDataManeuvering.SB40.vn.toFixed(1));
        } else {
          return null;
        }
      }
    },
    sternThruster2Pitch() {
      if (this.channelDataManeuvering) {
        if (isNumber(this.channelDataManeuvering.SB41.vn)) {
          return Number(this.channelDataManeuvering.SB41.vn.toFixed(1));
        } else {
          return null;
        }
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss"></style>
